/**
 * Runtime environment URLs derived from window.location.
 *
 * All URLs are derived automatically so org subdomain switching works
 * without manual env var changes — both locally and in production.
 */

const { origin } = window.location;

// Backend base URL (e.g. https://org.pluvo.co or http://org.localhost:8000)
// In dev, Vite runs on :3000 while the backend runs on :8000
export const ENV_BASE_URL = origin.replace(':3000', ':8000');

// GraphQL HTTP endpoint
export const ENV_GRAPHQL_URL = `${ENV_BASE_URL}/graphql/`;

// GraphQL WebSocket endpoint for subscriptions
// Swaps protocol: http→ws, https→wss (regex matches the "http" prefix in both)
export const ENV_GRAPHQL_WS_URL =
    ENV_BASE_URL.replace(/^http/, 'ws') + '/graphql/';

// Frontend origin URL, used for constructing redirect URLs
export const ENV_FRONTEND_URL = origin;
